import React, { useEffect, useState } from 'react';
import { getStoreList } from '../actions/storeActions';
import { useDispatch } from 'react-redux';
import PageLoader from './loader/PageLoader';
import Search from './search';
import packageInfo from '../../package.json';
import StoreList from './StoresList';
import CompanyTile from './tile/CompanyTile';
import { useSearchParams } from 'react-router-dom';

const STORE_STATE_KEY = 'selectedStore';

const CompaniesList = (props) => {
  const { storeList } = props;
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get('view') || 'companies';
  const companyParam = searchParams.get('company');
  const [searchTerm, setSearchTerm] = useState('');

  // Récupérer l'état initial depuis le localStorage
  const getInitialState = () => {
    const savedState = localStorage.getItem(STORE_STATE_KEY);
    return savedState
      ? JSON.parse(savedState)
      : {
          magasinChoice: '',
          actifStores: '',
          actifId: '',
          actifLogo: '',
        };
  };

  const [selectedStore, setSelectedStore] = useState(getInitialState());

  // Sauvegarder l'état dans le localStorage à chaque changement
  useEffect(() => {
    localStorage.setItem(STORE_STATE_KEY, JSON.stringify(selectedStore));
  }, [selectedStore]);

  // Restaurer la vue si un magasin était sélectionné
  useEffect(() => {
    if (selectedStore.actifId && !view) {
      setSearchParams({ view: 'stores' });
    }
  }, []);

  // Effet pour gérer le paramètre company dans l'URL
  useEffect(() => {
    if (companyParam && storeList.length > 0) {
      const company = storeList.find(
        (item) =>
          item.name.toLowerCase() ===
          decodeURIComponent(companyParam).toLowerCase(),
      );

      if (company) {
        handleSelectCompany(
          company._id,
          company.image,
          company.stores,
          company.name,
        );
      }
    }
  }, [companyParam, storeList]);

  const filteredStoreList = storeList
    ? storeList.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : [];

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleSelectCompany = (id, logo, stores, name) => {
    setSelectedStore({
      magasinChoice: name,
      actifStores: stores,
      actifId: id,
      actifLogo: logo,
    });
    setSearchParams({
      view: 'stores',
      company: encodeURIComponent(name.toLowerCase()),
    });
  };

  const handleReset = () => {
    setSelectedStore(getInitialState());
    localStorage.removeItem(STORE_STATE_KEY);
    setSearchParams({});
  };

  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      {/* Fond fixe qui couvre toute la page */}
      <div className="fixed inset-0 bg-gradient1" />

      {/* Vue des entreprises */}
      <div
        className={`
          relative z-10 w-full min-h-screen px-4 pt-6 pb-20
          transition-all duration-500 ease-in-out
          ${view === 'companies' ? 'translate-y-0' : '-translate-y-12 opacity-60 pointer-events-none'}
        `}
      >
        <div
          className={`
          store_list_title text-2xl font-bold mb-6
          transition-all duration-300
          w-full flex items-center justify-center
          geomanistMedium mt-6
          ${view === 'companies' ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}
        `}
        >
          Choix de l'enseigne
        </div>

        <div
          className={`
          transition-all duration-300 delay-100
          ${view === 'companies' ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}
        `}
        >
          <Search
            handleSearch={handleSearch}
            placeholder="Rechercher un magasin..."
          />
        </div>

        <div className="mt-6 space-y-5 px-6">
          {filteredStoreList.map((item, index) => {
            const isSelected = selectedStore.actifId === item._id;
            const delay = index * 50;

            return (
              <div
                key={item._id.slice(0, -1)}
                className={`
                  transition-all duration-500 ease-in-out
                   
                `}
                style={{
                  transitionDelay: `${delay}ms`,
                  opacity: isSelected && view === 'stores' ? 0 : 1,
                  transform: `
                    ${
                      view === 'companies'
                        ? 'translateY(0)'
                        : isSelected
                          ? 'translateY(-8px)'
                          : 'translateY(16px)'
                    }
                  `,
                }}
              >
                <CompanyTile
                  id={item._id}
                  name={item.name}
                  image={item.image}
                  onClick={() => {
                    handleSelectCompany(
                      item._id,
                      item.image,
                      item.stores,
                      item.name,
                    );
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Vue des magasins */}
      <div
        className={`
          fixed inset-0 bg-[#FFFBF1] 
          transition-all duration-500 ease-in-out z-20
          ${
            view === 'stores'
              ? 'translate-y-0 opacity-100'
              : 'translate-y-full opacity-0'
          }
        `}
      >
        <StoreList
          _id={selectedStore.actifId}
          image={selectedStore.actifLogo}
          stores={selectedStore.actifStores}
          name={selectedStore.magasinChoice}
          axiosInstance={props.axiosInstance}
          onReset={handleReset}
          prevPage={props.prevPage || null}
        />
      </div>

      {/* Version */}
      <div
        className={`
        fixed bottom-4 left-1/2 -translate-x-1/2 z-30
        transition-all duration-300
        ${view === 'companies' ? 'opacity-100' : 'opacity-0'}
      `}
      >
        <span className="text-[14px] text-gray-400/60 font-light">
          v{packageInfo.version}
        </span>
      </div>
    </div>
  );
};

export default CompaniesList;
